import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const CheckCircleIcon = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </svg>
)

const WarningIcon = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </svg>
)

const ErrorIcon = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
  </svg>
)

const STATUS_CONFIG = {
  'Operational': { icon: CheckCircleIcon, color: 'var(--vo-success)' },
  'In Progress': { icon: WarningIcon, color: 'var(--vo-warning)' },
  'Attention Required': { icon: ErrorIcon, color: 'var(--vo-danger)' },
}

const STATUS_KEYS = {
  'Operational': 'shared.status.operational',
  'In Progress': 'shared.status.inProgress',
  'Attention Required': 'shared.status.attentionRequired',
}

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

const Label = styled.span`
  font-size: 14px;
  color: var(--vo-slate);
`

export const StatusIndicator = ({ status, showLabel = true }) => {
  const { t } = useTranslation('transparency')
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['In Progress']
  const Icon = config.icon

  return (
    <Wrapper>
      <Icon color={config.color} />
      {showLabel && (
        <Label>{t(STATUS_KEYS[status] ?? STATUS_KEYS['In Progress'])}</Label>
      )}
    </Wrapper>
  )
}
